import { OnDestroy, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrgService } from '../org.service';
import { FormioLoader } from 'dp-formio';

@Component({
	selector: 'view-form',
	templateUrl: 'view-form.component.html',
	styleUrls: ['./view-form.component.scss'],
})
export class ViewFormDialog implements OnInit, OnDestroy {

	constructor(public dialogRef: MatDialogRef<ViewFormDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private loader: FormioLoader,
		private orgService: OrgService) {
	}
	ngOnInit(): void {
		this.getData();
	}
	ngOnDestroy(): void {
	}

	cancel() {
		this.dialogRef.close();
	}
	private getData() {
		this.loader.loading = true;
		this.orgService
			.getByEndpoint(this.data.endpoint)
			.pipe(
				finalize(() => this.loader.loading = false)
			)
			.subscribe((data) => {
				this.data.submission = data;
			});
	}
}
